import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiCrowdGeoSearchResponseBody,
  IApiCrowdSearchRequestBody,
} from '../CrowdApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseGeoSearchCrowdQueryValues = {
  appId: string;
  body: IApiCrowdSearchRequestBody;
};

export const geoSearchCrowdQueryKeyFactory: IQueryKeyFactory<
  IUseGeoSearchCrowdQueryValues
> = (values) =>
  values && (['geoSearchCrowd', values.appId, values.body] as const);

export const useGeoSearchCrowdQuery = (
  values?: IUseGeoSearchCrowdQueryValues,
  options?: UseQueryOptions<IApiCrowdGeoSearchResponseBody, ApiError>,
): UseQueryResult<IApiCrowdGeoSearchResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: geoSearchCrowdQueryKeyFactory(values),
    queryFn: values
      ? () => api.crowd.geoSearch(values.appId, values.body)
      : undefined,
    ...options,
  });
};
